// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { RegistrarService } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { ERR_TER_REGISTRAR_SVC, SUC_TER_REGISTRAR_SVC } from '../../../../utils/strings';

export const useTerminateRegistrarService = () => {
  const { submit } = useExerciseSubmission(
    RegistrarService.RegistrarService_Terminate,
    SUC_TER_REGISTRAR_SVC,
    ERR_TER_REGISTRAR_SVC,
  );
  return submit;
};
